module.exports = __webpack_public_path__ + "img/head.29bd2106.jpg";